export const STEP_HINT = {
    1: 'The type of campaign you choose affects your campaign’s Priority. Increase your Priority by choosing an ‘Entire catalog’ campaign.',
    2: 'The number of products you add to your campaign affects your campaign’s Priority. Increase your Priority by adding all available products.',
    3: 'The quality of your creative settings can affect your campaign’s Priority over time. Increase your Priority by choosing clear and compelling creative settings.',
    4: 'Both your campaign’s commission and Boosts affect your Priority. Increase your Priority by adjusting the commission you pay to Klickly.'
};
